import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cscontrolstruct(){

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    
    const right = {
      padding: '0 0 0 '+padding+'rem',
    };
return(
      <div>
      <Sides/>
        
        <Helmet>
 
 <title>Learn Free PHP Control Structure Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php control Structure tutorial for beginners.control Structure in Php is a program is executed as per requirement according to requirement the sequence can be changed by using the control structure statementr provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Php control Structure,Php control Structure for loop,control Structure foreach Php" />
 <link rel="canonical" href="https://www.codeexampler.com/php-control-structure" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Control structure statement in Php</h1>
    <div className="first">
        <a href="/php-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Types of control structure statement in Php</h2>

    <p className="mt-4 para">The program executes according to requirements. The sequence can be changed using the control structure statement. The categories and keywords show below:
</p>
    
<h2 className="mt-4 mh2">Conditional statements are many types in Php:<br/></h2>

<h3 className="mt-4 mh3">1, If-condition <br/>
2, If-else<br/>
3, If-else-if<br/>
4, Switch-case
</h3>
<h2 className="mt-4 mh2">Php looping (iteration)<br/></h2>
<h3 className="mt-4 mh3">There are three types of looping in Php:<br/>
</h3>
<h4 className="mt-4">1, While loop<br/>
2, Do-while loop<br/>
3, For loop<br/>
</h4>
<h2 className="mt-4 mh2">Jumping statements in Php:<br/></h2>
<h3 className="mt-4 mh3">Php supports only three types of jumping statements: 
<br/></h3>
<h4 className="mt-4">1, Control Structure<br/>
2, Continue<br/>
3, Goto
</h4>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/php-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cscontrolstruct;